import { Collapsebox } from './collapsebox.js';

export class CollapseboxGroupPfBenefits extends Collapsebox {

    constructor(component_key) {
        super(component_key);
    }

    init() {
        super.init();
    }
}
